import { Component } from '@angular/core';
import {ConnectionService} from 'ng-connection-service';  
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap'; 


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'railelearning'; 
  count=1;
  constructor(private connectionService: ConnectionService,private modalService: NgbModal) { 
   
    this.checkInternet();
  }  
  open(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {
    }, (reason) => {
    });
  }

  checkInternet(){
    this.connectionService.monitor().subscribe(isConnected => {  
       if (isConnected.hasNetworkConnection == true) { 
         document.getElementById('CloseIds')?.click();
       }  
       else {  
          document.getElementById('network')?.click();
          document.getElementById('CloseIds')?.click();
       }  
     })  
  }
}
